import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import IconReferralSource from 'components/icons/IconReferralSource';

const styles = () => ({
  root: {
    height: 330,
  },
  iconReferralSource: {
    width: 105,
    height: 105,
  },
});

const ReferralSourcesTableEmpty = ({ classes }) => (
  <Grid
    className={classes.root}
    container
    direction="column"
    justify="center"
    alignItems="center"
    spacing={24}
  >
    <Grid item>
      <IconReferralSource className={classes.iconReferralSource} />
    </Grid>
    <Grid item>
      <Typography variant="subheading" color="secondary">
        Unfortunately, there are no such referrals
      </Typography>
    </Grid>
  </Grid>
);

ReferralSourcesTableEmpty.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    iconReferralSource: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(ReferralSourcesTableEmpty);



// WEBPACK FOOTER //
// ./src/components/settings/ReferralSourcesTable/ReferralSourcesTableEmpty.js